exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.xml-schema{background-color:#e4e4e4;color:gray;margin-top:-10px;border-radius:0px;height:500px;text-align:left\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/src/pages/IntegrationDataPark/get.vue"],"names":[],"mappings":";AA6FA,YACE,yBACA,WACA,iBACA,kBACA,aACA,eAAgB;CAAG","file":"get.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.xml-schema, {\n  background-color: #e4e4e4;\n  color: gray;\n  margin-top: -10px;\n  border-radius: 0px;\n  height: 500px;\n  text-align: left; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49a924fb","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/IntegrationDataPark/get.vue
// module id = AOZ9
// module chunks = 149